export default {
  title: 'Informacje',
  sections: {
    work_schedule: 'Godziny otwarcia: zamówienia online',
    delivery_schedule: 'Czasy dostawy',
    delivery_costs: 'Koszty dostawy',
    website: 'Strona internetowa',
  },
  labels: {
    delivery_fees: 'Min. kwota – {{threshold}}, Opłata – {{fee}}',
  },
};
